import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	tooltip: {
		id: 'issue-create-commons.parent-link-field.tooltip',
		defaultMessage: 'Can only link a parent to issues without a linked epic.',
		description: 'when the epic link field value is set',
	},
});
